var map = {
	"./applePay.svg": "771b",
	"./gpay.svg": "95da",
	"./mastercard.svg": "ae11",
	"./megafon.svg": "a9dc",
	"./mir.svg": "163d",
	"./mts.svg": "953d",
	"./qiwi.svg": "d0c3",
	"./spay.svg": "fd39",
	"./tele2.svg": "9f2c",
	"./visa.svg": "86db",
	"./wmr.svg": "557b",
	"./wmz.svg": "090a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c882";